import React from 'react';

const EDGE_ITEMS = [
  { color: '#C9A84C', label: 'Spouse / Partner',   dash: false  },
  { color: '#1E3A5F', label: 'Parent / Child',      dash: false  },
  { color: '#7C3AED', label: 'Sibling',             dash: false  },
  { color: '#DB2777', label: 'Cousin',              dash: true   },
  { color: '#F59E0B', label: 'Cross-Memorial Link', dash: true   },
];

const CLUSTER_ITEMS = [
  { color: '#1E3A5F', label: 'Eleanor Thompson' },
  { color: '#7C3AED', label: 'Marcus Chen'      },
  { color: '#059669', label: 'Maya Rodriguez'   },
];

export default function LegacyChainLegend() {
  return (
    <div className="flex flex-wrap gap-8 text-[9px] font-black uppercase tracking-widest text-text-muted">
      {/* Edges */}
      <div>
        <p className="mb-2 text-accent-navy">Relationships</p>
        <div className="space-y-1.5">
          {EDGE_ITEMS.map(it => (
            <div key={it.label} className="flex items-center gap-2">
              <svg width={28} height={8}>
                <line x1={0} y1={4} x2={28} y2={4}
                  stroke={it.color} strokeWidth={2}
                  strokeDasharray={it.dash ? '5 3' : ''} />
              </svg>
              <span>{it.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Cousin badge explanation */}
      <div>
        <p className="mb-2 text-accent-navy">Node Badges</p>
        <div className="space-y-1.5">
          <div className="flex items-center gap-2">
            <div className="relative w-4 h-4">
              <div className="w-4 h-4 rounded-full border-2 border-dashed" style={{ borderColor: '#DB2777', background: '#FDF2F8' }} />
              <div className="absolute -top-1 -right-1 w-3 h-3 rounded-full flex items-center justify-center" style={{ background: '#DB2777' }}>
                <span className="text-white text-[6px] font-black">C</span>
              </div>
            </div>
            <span>Cousin node</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full border-2" style={{ background: '#1E3A5F', borderColor: '#C9A84C' }} />
            <span>Deceased</span>
          </div>
        </div>
      </div>

      {/* Clusters */}
      <div>
        <p className="mb-2 text-accent-navy">Memorial Clusters</p>
        <div className="space-y-1.5">
          {CLUSTER_ITEMS.map(it => (
            <div key={it.label} className="flex items-center gap-2">
              <div className="w-4 h-4 rounded-full flex-shrink-0" style={{ background: it.color }} />
              <span>{it.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}